import React from "react";
import styled from "styled-components";
import { BsArrowLeft } from "react-icons/bs";
import { NavLink } from "react-router-dom";
import { TbCurrencyNaira } from "react-icons/tb";

const DashTransConfirm = () => {
  return (
    <div>
      <Contain>
        {/* <NavLink to="">
                <Icon>
                    <BsArrowLeft />
                </Icon>
            </NavLink> */}

        <To>To</To>

        <Name>Damilola Sanni</Name>

        <Amount>
          {" "}
          <TbCurrencyNaira style={{ fontSize: "20px" }} /> 500,000.00
        </Amount>

        <Bank style={{ marginBottom: "10px", marginTop: "50px" }}>
          <Bank1>Bank</Bank1>
          <Bank2>United Bank for Africa</Bank2>
        </Bank>

        <Bank style={{ marginBottom: "50px" }}>
          <Bank1>Account Number</Bank1>
          <Bank2>2210563563</Bank2>
        </Bank>

        <Confirm>Confirm</Confirm>
      </Contain>
    </div>
  );
};

export default DashTransConfirm;

// const To = styled.div``;

const Icon = styled.div`
  position: absolute;
  top: -20px;
  left: 0px;
  font-size: 17px;
`;

const Confirm = styled.button`
  width: 100%;
  height: 40px;
  border-radius: 7px 7px 7px 0;
  /* margin-top: 25px; */
  border: none;
  background-color: #8a2be2;
  color: white;
  font-weight: 700;
  cursor: pointer;
`;

const Bank2 = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #8a2be2;
`;

const Bank1 = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #808080bf;
`;

const Bank = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Amount = styled.div`
  font-size: 20px;
  margin-top: 5px;
  font-weight: 600;
`;

const Name = styled.div`
  font-size: 14px;
  margin-top: 5px;
  font-weight: 600;
`;

const To = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #808080bf;
`;

const Contain = styled.div`
  width: 240px;
  height: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: black;
  position: relative;
`;
